// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.wrapper{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width:100vw;
    position:absolute;
    top:0;
    left:0;
    bottom:0;
    right:0;
    background-color: white;
    z-index: 999;
  }
  .wrapperBasic{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width:100vw;
    position:absolute;
    top:50px;
    left:0;
    bottom:0;
    right:0;
    background-color: white;
    z-index: 999;
  }
  .card {
    display: flex;
    padding: 24px;
    border-radius: 5px;
    min-height: 300px;
    min-width: 400px;
    background-color: #fbfbfb;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .loader{
     border-radius: 50%;
    position: relative;
    margin: 50px;
    display: inline-block;
    height: 0px;
    width: 0px;
  }
  
  .loader span{
      position: absolute;
      display: block;
      background: #ddd;
      height: 20px;
      width: 20px;
      border-radius: 50%;
      top: -20px;
      perspective: 100000px;
  }
  .loader span:nth-child(1) {
      left:60px;
      animation: bounce2 1s cubic-bezier(0.04, 0.35, 0, 1) infinite;
      animation-delay: 0s;
      background: #ff756f;
  }
  .loader span:nth-child(2) {
      left:20px;
      animation: bounce2 1s cubic-bezier(0.04, 0.35, 0, 1) infinite;
      animation-delay: .2s;
      background: #ffde6f;
  }
  .loader span:nth-child(3) {
      left:-20px;
      animation: bounce2 1s cubic-bezier(0.04, 0.35, 0, 1) infinite;
      animation-delay: .4s;
      background: #01de6f;
  }
  .loader span:nth-child(4) {
      left: -60px;
      animation: bounce2 1s cubic-bezier(0.04, 0.35, 0, 1) infinite;
      animation-delay: .6s;
      background: #6f75ff;
  }
  
  @keyframes bounce2 {
      0%, 75%, 100% {
          transform: translateY(0px);
      }
      25% {
          transform: translateY(-30px);
      }
  }`, "",{"version":3,"sources":["webpack://./src/app/components/loadingMask/loadingMask.component.css"],"names":[],"mappings":";;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,KAAK;IACL,MAAM;IACN,QAAQ;IACR,OAAO;IACP,uBAAuB;IACvB,YAAY;EACd;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,QAAQ;IACR,MAAM;IACN,QAAQ;IACR,OAAO;IACP,uBAAuB;IACvB,YAAY;EACd;EACA;IACE,aAAa;IACb,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;EACA;KACG,kBAAkB;IACnB,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;IACrB,WAAW;IACX,UAAU;EACZ;;EAEA;MACI,kBAAkB;MAClB,cAAc;MACd,gBAAgB;MAChB,YAAY;MACZ,WAAW;MACX,kBAAkB;MAClB,UAAU;MACV,qBAAqB;EACzB;EACA;MACI,SAAS;MACT,6DAA6D;MAC7D,mBAAmB;MACnB,mBAAmB;EACvB;EACA;MACI,SAAS;MACT,6DAA6D;MAC7D,oBAAoB;MACpB,mBAAmB;EACvB;EACA;MACI,UAAU;MACV,6DAA6D;MAC7D,oBAAoB;MACpB,mBAAmB;EACvB;EACA;MACI,WAAW;MACX,6DAA6D;MAC7D,oBAAoB;MACpB,mBAAmB;EACvB;;EAEA;MACI;UACI,0BAA0B;MAC9B;MACA;UACI,4BAA4B;MAChC;EACJ","sourcesContent":["\r\n\r\n.wrapper{\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 100vh;\r\n    width:100vw;\r\n    position:absolute;\r\n    top:0;\r\n    left:0;\r\n    bottom:0;\r\n    right:0;\r\n    background-color: white;\r\n    z-index: 999;\r\n  }\r\n  .wrapperBasic{\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 100vh;\r\n    width:100vw;\r\n    position:absolute;\r\n    top:50px;\r\n    left:0;\r\n    bottom:0;\r\n    right:0;\r\n    background-color: white;\r\n    z-index: 999;\r\n  }\r\n  .card {\r\n    display: flex;\r\n    padding: 24px;\r\n    border-radius: 5px;\r\n    min-height: 300px;\r\n    min-width: 400px;\r\n    background-color: #fbfbfb;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n  .loader{\r\n     border-radius: 50%;\r\n    position: relative;\r\n    margin: 50px;\r\n    display: inline-block;\r\n    height: 0px;\r\n    width: 0px;\r\n  }\r\n  \r\n  .loader span{\r\n      position: absolute;\r\n      display: block;\r\n      background: #ddd;\r\n      height: 20px;\r\n      width: 20px;\r\n      border-radius: 50%;\r\n      top: -20px;\r\n      perspective: 100000px;\r\n  }\r\n  .loader span:nth-child(1) {\r\n      left:60px;\r\n      animation: bounce2 1s cubic-bezier(0.04, 0.35, 0, 1) infinite;\r\n      animation-delay: 0s;\r\n      background: #ff756f;\r\n  }\r\n  .loader span:nth-child(2) {\r\n      left:20px;\r\n      animation: bounce2 1s cubic-bezier(0.04, 0.35, 0, 1) infinite;\r\n      animation-delay: .2s;\r\n      background: #ffde6f;\r\n  }\r\n  .loader span:nth-child(3) {\r\n      left:-20px;\r\n      animation: bounce2 1s cubic-bezier(0.04, 0.35, 0, 1) infinite;\r\n      animation-delay: .4s;\r\n      background: #01de6f;\r\n  }\r\n  .loader span:nth-child(4) {\r\n      left: -60px;\r\n      animation: bounce2 1s cubic-bezier(0.04, 0.35, 0, 1) infinite;\r\n      animation-delay: .6s;\r\n      background: #6f75ff;\r\n  }\r\n  \r\n  @keyframes bounce2 {\r\n      0%, 75%, 100% {\r\n          transform: translateY(0px);\r\n      }\r\n      25% {\r\n          transform: translateY(-30px);\r\n      }\r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
